export default __webpack_public_path__ + "static/media/icon-operations.aab216a3.svg";